import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { FsLprFilterCamera } from './lpr-filter-camera';
import { FsLprFilterPlateAttributes } from './lpr-filter-plate-attributes';
import { FsLprFilterVehicleAttributes } from './lpr-filter-vehicle-attributes';

export class FsLprFilters extends SnModel {
  @Expose()
  public plateAttributes: FsLprFilterPlateAttributes;

  @Expose()
  public vehicleAttributes: FsLprFilterVehicleAttributes;

  @Expose()
  public camera: FsLprFilterCamera;

  constructor(data = {}) {
    super();
    this.fromJSON(data);
  }
}
